import { Grid } from '@mui/material'
import { Metrics } from '@operations/features/craneSplit/models/metric.model'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import _ from 'lodash'
import { MetricCard } from '../MetricCard/MetricCard'

interface Props {
  metrics: Metrics
  isExporting?: boolean
}

export const MetricList = ({ metrics, isExporting }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  return (
    <Grid
      container
      spacing={isExporting ? theme.customSpacing.s : theme.customSpacing.l}
      marginLeft={isExporting ? theme.customSpacing.s : undefined}
      marginRight={isExporting ? theme.customSpacing.s : undefined}
      id='metric-list'
    >
      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <MetricCard
          title={t('moves', 'Moves')}
          total={_.sumBy(metrics.moves, x => x.total)}
          items={metrics.moves}
          itemTitleDataCy='crane-split-moves-metric-item-title'
        ></MetricCard>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <MetricCard
          title={t('containers', 'Containers')}
          total={_.sumBy(metrics.containers, x => x.total)}
          items={metrics.containers}
        ></MetricCard>
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 4,
        }}
      >
        <MetricCard
          title={t('hours', 'Hours')}
          total={_.sumBy(metrics.hours, x => x.total)}
          items={metrics.hours}
          titleDataCy='crane-split-hours-metric-title'
        ></MetricCard>
      </Grid>
    </Grid>
  )
}
